import React from 'react';

import { FormattedMessage } from 'react-intl';

import { IconButton } from '@atlaskit/button/new';
import { FlagsProvider } from '@atlaskit/flag';
import CrossIcon from '@atlaskit/icon/core/cross';
import { fg } from '@atlaskit/platform-feature-flags';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Flex, Stack, Text, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import { messages } from './messages';

const titleWrapperStyles = xcss({
	minWidth: '270px',
	paddingBlock: 'space.100',
});

const closeIconWrapperStyles = xcss({
	marginLeft: 'auto',
});

const containerStyles = xcss({
	height: '100%',
});

type ExtensionsConfigWrapperProps = React.PropsWithChildren<{
	buttonIcon?: React.ReactNode;
	closeConfigPanel: () => void;
	footerComponent?: React.FC;
	title: React.ReactNode;
}>;

export const ExtensionsConfigWrapper = ({
	title,
	children,
	footerComponent: FooterComponent,
	buttonIcon = null,
	closeConfigPanel,
}: ExtensionsConfigWrapperProps): React.JSX.Element => (
	<FlagsProvider>
		<Flex
			columnGap="space.300"
			justifyContent="space-between"
			direction="column"
			xcss={containerStyles}
		>
			<Stack space="space.300">
				<Flex justifyContent="start" alignItems="center" gap="space.100" xcss={titleWrapperStyles}>
					{buttonIcon}
					<Text size="large" weight="medium">
						{title}
					</Text>
					<Box xcss={closeIconWrapperStyles}>
						<Tooltip hideTooltipOnClick content={<FormattedMessage {...messages.close} />}>
							<IconButton
								onClick={closeConfigPanel}
								appearance="subtle"
								icon={CrossIcon}
								label={<FormattedMessage {...messages.close} />}
								testId="panel-close-button"
								isTooltipDisabled={false}
							/>
						</Tooltip>
					</Box>
				</Flex>
				{children}
			</Stack>
			{FooterComponent &&
				(fg('pcs-3808077-links-menu-react-compiler-fixes') ? (
					<FooterComponent />
				) : (
					FooterComponent({})
				))}
		</Flex>
	</FlagsProvider>
);
